var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33268 1.33203H1.99935C1.64573 1.33203 1.30659 1.47251 1.05654 1.72256C0.806491 1.9726 0.666016 2.31174 0.666016 2.66536V13.332C0.666016 13.6857 0.806491 14.0248 1.05654 14.2748C1.30659 14.5249 1.64573 14.6654 1.99935 14.6654H9.99935C10.353 14.6654 10.6921 14.5249 10.9422 14.2748C11.1922 14.0248 11.3327 13.6857 11.3327 13.332V5.33203M7.33268 1.33203L11.3327 5.33203M7.33268 1.33203L7.33268 5.33203H11.3327M8.66602 8.66536H3.33268M8.66602 11.332H3.33268M4.66602 5.9987H3.33268",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.784895bcfa34260d2f8c922d3f5f8a94.svg";
export { ForwardRef as ReactComponent };